<template>
  <page :manualInit="claimRegister.init" :manualErr="claimRegister.initErr" @reload="doInit">
    <transition name="slide-x-transition" mode="out-in">
      <router-view :toggleQuery="toggleQuery"></router-view>
    </transition>
    <v-navigation-drawer temporary clipped fixed right hide-overlay v-model="lifeCycle" width="400">
      <claim-life-cycle @statusChange="editStatusChange" :query="query"></claim-life-cycle>
    </v-navigation-drawer>
  </page>
</template>

<script>
import ClaimLifeCycle from '@/components/core/claimManagement/register/ClaimLifeCycle'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      tour: undefined,
      lifeCycle: false,
      statusChange: false,
      saveError: false,
      query: false,
      breadcrumb: [],
      selectedKey: undefined,
      control: [
        { name: 'statistics', show: false },
        { name: 'text', show: false },
        { name: 'reinsurance', show: false },
        { name: 'clmhandler', show: false },
        { name: 'clmattachfile', show: false }
      ]
    }
  },
  watch: {
    saveErrorMsg: {
      handler: function (value) {
        if ((value.messages && value.messages.length > 0) || (value.fieldMessages && value.fieldMessages.length > 0)) {
          this.saveError = true
        }
      },
      deep: true
    }
  },
  computed: {
    claimRegister() {
      return this.$store.state.claims.claimRegister
    },
    saveErrorMsg() {
      return this.$store.state.claims.claimDetail.saveError
    },
    renderComments() {
      if (this.$route.name !== 'claimRegister' && this.$store.state.claims.claimDetail.claimLifeCycle > 1) {
        return true
      } else {
        return false
      }
    },
    sideFunction() {
      let result = [
        { text: 'Claim Text', icon: 'mdi-note-text', iconColor: 'primary', params: { key: 'text' } },
        { text: 'Reinsurance', icon: 'mdi-folder', iconColor: 'primary', params: { key: 'reinsurance' } },
        { text: 'Claim Handler', icon: 'mdi-account-network', iconColor: 'primary', params: { key: 'clmhandler' } },
        { text: 'Attach File', icon: 'mdi-attachment', iconColor: 'primary', params: { key: 'clmattachfile' } }
      ]
      if (this.$route.name === 'qClaimHeader') {
        result.push({ text: 'Statistics', icon: 'mdi-chart-areaspline', iconColor: 'primary', params: { key: 'statistics' } })
      }
      return result
    }
  },
  methods: {
    sideMenuClick(data) {
      var foundIndex = this.control.findIndex((x) => x.name === data.key)
      this.control[foundIndex].show = true
    },
    getSideControlMenu(key) {
      for (let param of this.control) {
        if (param.name === key) {
          return param
        }
      }
      return {}
    },
    async doInit() {
      await this.$store.dispatch('claimsRegisterInit')
    },
    toggleQuery(isQueryMode = false) {
      this.query = isQueryMode
    },
    editStatusChange() {
      this.lifeCycle = false
      this.statusChange = true
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    ClaimLifeCycle
  },
  mixins: [routeMixin]
}
</script>

<style lang="scss">
// Side info for all quotation
.quoteSideInfo {
  // Overwrite toolbar margin on side info
  .toolbar__content > *:not(.btn):not(.menu):last-child,
  .toolbar__extension > *:not(.btn):not(.menu):last-child {
    margin-right: 0px;
  }
}
// Internal quotation lifecycle for all quotation
.quoteLifeCycle {
  &.v-stepper {
    background: none !important;
    box-shadow: none !important;
  }
}
</style>
